import { Input } from '@/components/ui/input';
import { InputElementBase } from '../utils/types';

export default function GenericFormInput({
  disabled,
  placeholder,
  type,
  name,
  onBlur,
  onChange,
  ref,
  value,
  autoComplete,
}: Exclude<InputElementBase, 'label' | 'description' | 'className'>) {
  return (
    <Input
      type={type || 'text'}
      placeholder={placeholder || undefined}
      disabled={disabled}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      ref={ref}
      value={value ? String(value) : ''}
      autoComplete={autoComplete}
    />
  );
}
